export default __webpack_public_path__ + "static/cli_alvi-2ccfea1c6dd4454897987500fcc55adb.png";